class Accordion extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('accordion-item'));

    this.items.forEach((item) => {
      item.addEventListener('toggle', this.handleToggle);
    });
  }

  disconnectedCallback() {
    this.items.forEach((item) => {
      item.removeEventListener('toggle', this.handleToggle);
    });
  }

  handleToggle(event) {
    const openItem = event.target;

    this.items.forEach((item) => {
      if (item !== openItem) {
        item.closeAccordion();
      }
    });
  }
}

customElements.define('accordion-group', Accordion);
class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.updateHeight = this.updateHeight.bind(this);
    this.debouncedUpdateHeight = debounce(
      this.updateHeight,
      ON_CHANGE_DEBOUNCE_TIMER
    );
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.content = this.querySelector('.content');
    this.icon = this.querySelector('.icon');

    if (this.button) {
      this.button.addEventListener('click', this.toggleAccordion);
    }

    // Check initial open state based on attribute
    this.isOpen = this.hasAttribute('is-open');
    this.renderState();

    window.addEventListener('resize', this.debouncedUpdateHeight);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.toggleAccordion);
    }

    window.removeEventListener('resize', this.debouncedUpdateHeight);
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.renderState();
    this.dispatchEvent(new Event('toggle', { bubbles: true }));
  }

  closeAccordion() {
    this.isOpen = false;
    this.renderState();
  }

  updateHeight() {
    if (this.isOpen) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }
  }

  renderState() {
    this.content.style.maxHeight = this.isOpen
      ? `${this.content.scrollHeight}px`
      : '0';

    this.icon.classList.toggle('rotate-180', this.isOpen);
    this.icon.classList.toggle('rotate-0', !this.isOpen);
    this.classList.toggle('is-open', this.isOpen);
    this.classList.toggle('is-close', !this.isOpen);

    if (this.isOpen) {
      this.setAttribute('is-open', '');
    } else {
      this.removeAttribute('is-open');
    }
  }
}

customElements.define('accordion-item', AccordionItem);
